"use client";

import { Label } from "@/components/ui/label";
import { BrandInput } from "@/components/brand/brand-input";
import { Search } from "lucide-react";

interface FilterSection {
  title: string;
  options: string[];
}

interface SidebarFilterProps {
  selected: Record<string, string[]>;
  onToggle: (section: string, option: string) => void;
  search: string;
  onSearchChange: (value: string) => void;
  sections?: FilterSection[];
}

export const SidebarFilter = ({
  selected,
  onToggle,
  search,
  onSearchChange,
  sections,
}: SidebarFilterProps) => {
  const filterSections: FilterSection[] = sections || [
    { title: "Urutkan", options: ["Terbaru"] },
    { title: "Kategori", options: [] },
    { title: "Tipe", options: ["Gratis", "Berbayar"] },
  ];

  return (
    <aside className="hidden w-[220px] shrink-0 lg:block">
      <div className="border-border bg-card hover:border-primary/20 shadow-soft sticky top-[72px] max-h-[calc(100vh-90px)] overflow-y-auto rounded-2xl border p-5 transition-all duration-200 [--soft-shadow-color:var(--border)] hover:-translate-y-1">
        <h3 className="text-foreground mb-4 text-base font-extrabold">Filter</h3>

        <div className="relative mb-5">
          <div className="text-foreground/40 pointer-events-none absolute top-1/2 left-3 -translate-y-1/2">
            <Search size={14} />
          </div>
          <BrandInput
            variant="filter"
            type="text"
            placeholder="Cari ujian..."
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pr-3 pl-8"
          />
        </div>

        <div className="flex flex-col gap-6">
          {filterSections
            .filter((s) => s.options.length > 0)
            .map((section) => (
              <div key={section.title}>
                <h4 className="text-foreground text-2xs mb-3 font-extrabold tracking-wider uppercase">
                  {section.title}
                </h4>
                <div className="flex flex-col gap-2.5">
                  {section.options.map((option) => {
                    const isActive = selected[section.title]?.includes(option);
                    return (
                      <Label
                        key={option}
                        className="text-foreground hover:text-primary flex cursor-pointer items-center gap-2.5 text-sm transition-colors"
                        onClick={() => onToggle(section.title, option)}
                      >
                        <div
                          className={`flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-sm border transition-all active:scale-90 ${isActive ? "border-primary bg-primary shadow-soft-sm [--soft-shadow-color:var(--primary)]" : "border-muted-foreground bg-card"}`}
                        >
                          {isActive && (
                            <svg
                              className="anim-pop"
                              width="10"
                              height="8"
                              viewBox="0 0 10 8"
                              fill="none"
                            >
                              <path
                                d="M1 4L3.5 6.5L9 1"
                                stroke="white"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          )}
                        </div>
                        <span className={isActive ? "text-foreground font-medium" : ""}>
                          {option}
                        </span>
                      </Label>
                    );
                  })}
                </div>
              </div>
            ))}
        </div>
      </div>
    </aside>
  );
};
